import React, { useState } from "react";
import LoadingButton from "../../dumb/LoadingButton";
import useModal from "../../../hook/useModal";
import DisplayError from "../../dumb/DisplayError";
import useStatusThunk from "../../../hook/useStatusThunk";
import PassInput from "../../dumb/PassInput";
import { setUserPassword } from "../../../redux/ducks/user";
import CheckInput from "../../dumb/CheckInput";

const SetUserPassword = props => {
    const [show, hide, renderModal] = useModal();
    const [d_setUserPassword, status, error, event] = useStatusThunk(setUserPassword);

    const [password, setPassword] = useState();
    const [sendEmail, setSendEmail] = useState(true);

    event.onSuccess = () => {
        hide();
        setPassword(null);
        setSendEmail(null);
    }

    return (
        <React.Fragment>
            <button className={"button button--primary " + props.className} onClick={show}>Set Password</button>

            {renderModal(
                <React.Fragment>
                    <div className="group">
                        <div className="label">Password</div>
                        <PassInput set={setPassword} v={password} />
                    </div>

                    <div className="group">
                        <div className="label">Send Email</div>
                        <CheckInput set={setSendEmail} v={sendEmail} />
                    </div>

                    <div className="group">
                        <DisplayError error={error} />
                    </div>

                    <LoadingButton loading={status == "pending"} className="button--primary" onClick={() => { d_setUserPassword({ userID: props.userID, password, sendEmail }) }}>Set Password</LoadingButton>
                </React.Fragment>
            )}
        </React.Fragment>
    )
}

export default SetUserPassword;